module.exports = __webpack_public_path__ + "img/Venomanger.7a9e1f99.png";